// The text_task LLM wraps key terms in `<concept id="…">…</concept>` spans
// (driven by the Langfuse prompt). The concept-hover feature has been
// retired - we strip the wrapper and keep only the inner text so the
// concept becomes invisible to the reader. Citations are now the only
// special inline signal in the prose.
//
// LLMs sometimes defensively wrap raw HTML/XML in inline-code backticks
// (e.g. `<concept id="…">…</concept>`); the optional `\`?` on each side
// catches that variant so the backticks don't leak into the rendered
// prose as inline code.
const CONCEPT_SPAN_RE =
  /`?<concept\s+id\s*=\s*"([^"]+)"\s*>([\s\S]*?)<\/concept>`?/g;

// A tag left without its pair (the model closed a span twice, or never
// closed one). Left in, raw HTML parsing took everything after it with it:
// the rest of the lesson rendered as unformatted text.
const STRAY_TAG_RE = /`?<\/?concept\b[^>]*>`?/g;

export function stripConceptSpans(markdown: string): string {
  return markdown
    .replace(CONCEPT_SPAN_RE, (_match, _conceptId, inner) => {
      const text = String(inner);
      // A span across paragraphs keeps its paragraphs (and display maths).
      return /\n\s*\n/.test(text) ? text : text.replace(/\s+/g, ' ').trim();
    })
    .replace(STRAY_TAG_RE, '');
}
